export default __webpack_public_path__ + "static/media/pay_3.d7e60345.png";